import { render, staticRenderFns } from "./SmallDetailsLoader.vue?vue&type=template&id=2c7c02d0&scoped=true"
import script from "./SmallDetailsLoader.vue?vue&type=script&lang=ts"
export * from "./SmallDetailsLoader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsLoader.vue?vue&type=style&index=0&id=2c7c02d0&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SmallDetailsLoader.vue?vue&type=style&index=1&id=2c7c02d0&prod&scoped=true&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2c7c02d0",
  null
  ,true
)

export default component.exports